<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Maestro de Reportes</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-tabs>
            <v-tab align-with-title="true">
                <v-icon left>mdi-email</v-icon>
                Reporte Vigente
            </v-tab>

            <v-tab align-with-title="true">
                <v-icon left>mdi-email</v-icon>
                Reporte Histórico
            </v-tab>

            <v-tab align-with-title="true">
                <v-icon left>mdi-email</v-icon>
                Reportes Importados
            </v-tab>

            <v-tab-item>
                <v-card>
                    <v-card-text>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-data-table
                        :headers="headers"
                        :items="datawork"
                        :items-per-page="5"
                        class="elevation-1"
                        :search="search"
                    >
                    </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-btn dark color="blue" @click="exportExcel(datawork)" v-if="datawork.length>0">
                        <v-icon>mdi-file-excel-box</v-icon>
                        Exportar Excel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-card-text>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-data-table
                        :headers="headers"
                        :items="dataworkAnt"
                        :items-per-page="5"
                        class="elevation-1"
                        :search="search"
                    >
                    </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-btn dark color="blue" @click="exportExcel(dataworkAnt)" v-if="dataworkAnt.length>0">
                        <v-icon>mdi-file-excel-box</v-icon>
                        Exportar Excel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-card-text>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-data-table
                        :headers="headers"
                        :items="datosImport"
                        :items-per-page="5"
                        class="elevation-1"
                        :search="search"
                    >
                    </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-btn dark color="blue" @click="exportExcel(datosImport)" v-if="datosImport.length>0">
                        <v-icon>mdi-file-excel-box</v-icon>
                        Exportar Excel</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn dark color="success" @click="importar">
                        <v-icon>mdi-file-excel-box</v-icon>
                        Importar Evaluaciones</v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>                   
        </v-tabs>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import store from "../store";
import router from '../router';
import XLSX from 'xlsx';
export default {
    name: 'Reportes',
    data() {
        return {
            apiPath: "reporte",
            search: "",
            dialog: false,
            headers: [
            { text: "Codigo", align: "start", sortable: true, value: "codigo" },
            { text: "Apellidos", sortable: true, value: "apellidos" },
            { text: "Nombres", sortable: true, value: "nombres" },
            { text: "Correo", sortable: true, value: "correo" },
            { text: "Cargo", sortable: true, value: "cargo" },
            { text: "Codigo Depto", sortable: true, value: "codigo_depto" },
            { text: "Departamento", sortable: true, value: "depto" },
            { text: "Supervisor", sortable: true, value: "supervisor" },
            { text: "Grupo", sortable: true, value: "depto" },
            { text: "Evaluacion", sortable: true, value: "evaluacion" },
            { text: "Etapa", sortable: true, value: "etapa" },
            { text: "Calificacion Medio Año", sortable: true, value: "calificacion_sup" },
            { text: "Calificacion Fin Año", sortable: true, value: "calificacionfin_sup" },
            { text: "Numero de Objetivos", sortable: true, value: "nroObj" },
            { text: "Valor de Objetivos", sortable: true, value: "vobj" },
            
            { text: "Promedio Obj Med Año Col", sortable: true, value: "promObEvMedCol" },
            { text: "Promedio Obj Med Año Sup", sortable: true, value: "promObEvMedSup" },
            { text: "Promedio Obj Fin Año Col", sortable: true, value: "promObEvFinCol" },
            { text: "Promedio Obj Fin Año Sup", sortable: true, value: "promObEvFinSup" },
            { text: "Numero de Competencias", sortable: true, value: "nroCom" },
            { text: "Valor de Competencias", sortable: true, value: "vcom" },
          
            { text: "Promedio Com Med Año Col", sortable: true, value: "promCoEvMedCol" },
            { text: "Promedio Com Med Año Sup", sortable: true, value: "promCoEvMedSup" },
            { text: "Promedio Com Fin Año Col", sortable: true, value: "promCoEvFinCol" },
            { text: "Promedio Com Fin Año Sup", sortable: true, value: "promCoEvFinSup" },
            { text: "Nota Ponderada Medio Año", sortable: true, value: "ponMed" },         
            { text: "Nota Ponderada Fin Año", sortable: true, value: "ponFin" },
            ],
            datos: [], datawork: [], dataworkAnt: [], datosImport: [],
            selec: '',
            editedIndex: -1,
            editedItem: {},
            defaultItem: {
                id: '', nombre: '', descripcion: '', peso: '', casoexito: '', resultados: '',
            }
        }
    },
    created() {
        this.editedItem = Object.assign({}, this.defaultItem);
    },
    mounted() {
    axios
      .get(api.api + this.apiPath + '/reportevigentes')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          this.datos.push(r.data[i])
          for(let y = 0; y < r.data[i].evcol.length; y++){
            try{
              let data = {
                    codigo: r.data[i].codigo,
                    apellidos: r.data[i].apellidos,
                    nombres: r.data[i].nombres,
                    correo: r.data[i].correo,
                    cargo: r.data[i].cargo,
                    codigo_depto: r.data[i].codigo_depto,
                    depto: r.data[i].depto,
                    supervisor: r.data[i].sup,
                    grupo: r.data[i].grupo,
                    calificacion_sup: r.data[i].evcol[y].calificacion_sup,
                    calificacionfin_sup: r.data[i].evcol[y].calificacionfin_sup,
                    etapa: r.data[i].evcol[y].etapa,
                    evaluacion: r.data[i].evcol[y].evaluacion.descripcion,
                    vcom: r.data[i].evcol[y].evaluacion.bcompetencias,
                    vobj: r.data[i].evcol[y].evaluacion.bobjetivos,
              }
            let ocalificacionmed_col = 0
            let ocalificacionmed_sup = 0
            let ocalificacionfin_col = 0
            let ocalificacionfin_sup = 0

            let ponObj = []

              for(let o = 0; o < r.data[i].evcol[y].obj.length; o++){
                data.nroObj = r.data[i].evcol[y].obj.length //Pendiente con el +1
                ocalificacionmed_col = ocalificacionmed_col + r.data[i].evcol[y].obj[o].calificacionmed_col
                ocalificacionmed_sup = ocalificacionmed_sup + r.data[i].evcol[y].obj[o].calificacionmed_sup
                ocalificacionfin_col = ocalificacionfin_col + r.data[i].evcol[y].obj[o].calificacionfin_col
                ocalificacionfin_sup = ocalificacionfin_sup + r.data[i].evcol[y].obj[o].calificacionfin_sup
                let calObj = {
                  autoevaluacion: r.data[i].evcol[y].evaluacion.autoevaluacion,
                  medioano: r.data[i].evcol[y].evaluacion.medioano,
                  cal_med_col: r.data[i].evcol[y].obj[o].calificacionmed_col,
                  cal_med_sup: r.data[i].evcol[y].obj[o].calificacionmed_sup,
                  cal_fin_col: r.data[i].evcol[y].obj[o].calificacionfin_col,
                  cal_fin_sup: r.data[i].evcol[y].obj[o].calificacionfin_sup,
                  peso: r.data[i].evcol[y].obj[o].peso,
                }
                ponObj.push(calObj)
              }

            data.promObEvMedCol = (ocalificacionmed_col / data.nroObj).toFixed(2)
            data.promObEvMedSup = (ocalificacionmed_sup / data.nroObj).toFixed(2)
            data.promObEvFinCol = (ocalificacionfin_col / data.nroObj).toFixed(2)
            data.promObEvFinSup = (ocalificacionfin_sup / data.nroObj).toFixed(2)

            let ccalificacionmed_col = 0
            let ccalificacionmed_sup = 0
            let ccalificacionfin_col = 0
            let ccalificacionfin_sup = 0

            let ponCom = []

              for(let o = 0; o < r.data[i].evcol[y].com.length; o++){
                data.nroCom = r.data[i].evcol[y].com.length //Pendiente con el +1
                ccalificacionmed_col = ccalificacionmed_col + r.data[i].evcol[y].com[o].calificacionmed_col
                ccalificacionmed_sup = ccalificacionmed_sup + r.data[i].evcol[y].com[o].calificacionmed_sup
                ccalificacionfin_col = ccalificacionfin_col + r.data[i].evcol[y].com[o].calificacionfin_col
                ccalificacionfin_sup = ccalificacionfin_sup + r.data[i].evcol[y].com[o].calificacionfin_sup
                let calCom = {
                  autoevaluacion: r.data[i].evcol[y].evaluacion.autoevaluacion,
                  medioano: r.data[i].evcol[y].evaluacion.medioano,
                  cal_med_col: r.data[i].evcol[y].com[o].calificacionmed_col,
                  cal_med_sup: r.data[i].evcol[y].com[o].calificacionmed_sup,
                  cal_fin_col: r.data[i].evcol[y].com[o].calificacionfin_col,
                  cal_fin_sup: r.data[i].evcol[y].com[o].calificacionfin_sup,
                  peso: r.data[i].evcol[y].com[o].peso,
                }
                ponCom.push(calCom)                
              }
            data.promCoEvMedCol = (ccalificacionmed_col / data.nroCom).toFixed(2)
            data.promCoEvMedSup = (ccalificacionmed_sup / data.nroCom).toFixed(2)
            data.promCoEvFinCol = (ccalificacionfin_col / data.nroCom).toFixed(2)
            data.promCoEvFinSup = (ccalificacionfin_sup / data.nroCom).toFixed(2)

            let ponMed = ''
            let ponFin = ''

            for(let i = 0; i < ponCom.length; i++){
              let ponderadaMed = 0
              let ponderadaFin = 0
              if(ponCom[i].autoevaluacion == 1 && ponCom[i].medioano == 1){
                ponderadaMed = ((((ponCom[i].cal_med_col + ponCom[i].cal_med_sup) / 2) * ponCom[i].peso) / 100)
              }else if(ponCom[i].medioano == 1){
                ponderadaMed = (((ponCom[i].cal_med_sup) * ponCom[i].peso) / 100)
              }else{
                ponderadaMed = 'N/A'
                ponMed = 'N/A'
              }
              if(ponCom[i].autoevaluacion == 1){
                ponderadaFin = ((((ponCom[i].cal_fin_col + ponCom[i].cal_fin_sup) / 2) * ponCom[i].peso) / 100)
              }else{
                ponderadaFin = (((ponCom[i].cal_fin_sup) * ponCom[i].peso) / 100)
              }

              if(ponderadaMed != 'N/A'){
                ponderadaMed = ((ponderadaMed * data.vcom) / 100)
                ponMed = ((ponMed*1) + ponderadaMed).toFixed(2)
              }
                ponderadaFin = ((ponderadaFin * data.vcom) / 100)
                ponFin = ((ponFin*1) + ponderadaFin).toFixed(2)
            }

            for(let i = 0; i < ponObj.length; i++){
              let ponderadaMed = 0
              let ponderadaFin = 0
              if(ponObj[i].autoevaluacion == 1 && ponObj[i].medioano == 1){
                ponderadaMed = ((((ponObj[i].cal_med_col + ponObj[i].cal_med_sup) / 2) * ponObj[i].peso) / 100)
              }else if(ponObj[i].medioano == 1){
                ponderadaMed = (((ponObj[i].cal_med_sup) * ponObj[i].peso) / 100)
              }else{
                ponderadaMed = 'N/A'
                ponMed = 'N/A'
              }
              if(ponObj[i].autoevaluacion == 1){
                ponderadaFin = ((((ponObj[i].cal_fin_col + ponObj[i].cal_fin_sup) / 2) * ponObj[i].peso) / 100)
              }else{
                ponderadaFin = (((ponObj[i].cal_fin_sup) * ponObj[i].peso) / 100)
              }

              if(ponderadaMed != 'N/A'){
                ponderadaMed = ((ponderadaMed * data.vobj) / 100)
                ponMed = ((ponMed*1) + ponderadaMed).toFixed(2)
              }
                ponderadaFin = ((ponderadaFin * data.vobj) / 100)
                ponFin = ((ponFin*1) + ponderadaFin).toFixed(2)
            }
            data.ponMed = ponMed
            data.ponFin = ponFin
            this.datawork.push(data)
            } catch{
              console.log('No porcesada')
            }
          }
        }
      })
      .catch(error => {
        console.log(error);
      });

    axios
      .get(api.api + this.apiPath + '/reportehistorico')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          this.datos.push(r.data[i])
          for(let y = 0; y < r.data[i].evcol.length; y++){
            try{
              let data = {
                    codigo: r.data[i].codigo,
                    apellidos: r.data[i].apellidos,
                    nombres: r.data[i].nombres,
                    correo: r.data[i].correo,
                    cargo: r.data[i].cargo,
                    codigo_depto: r.data[i].codigo_depto,
                    depto: r.data[i].depto,
                    supervisor: r.data[i].sup,
                    grupo: r.data[i].grupo,
                    calificacion_sup: r.data[i].evcol[y].calificacion_sup,
                    calificacionfin_sup: r.data[i].evcol[y].calificacionfin_sup,
                    etapa: r.data[i].evcol[y].etapa,
                    evaluacion: r.data[i].evcol[y].evaluacion.descripcion,
                    vcom: r.data[i].evcol[y].evaluacion.bcompetencias,
                    vobj: r.data[i].evcol[y].evaluacion.bobjetivos,
              }
            let ocalificacionmed_col = 0
            let ocalificacionmed_sup = 0
            let ocalificacionfin_col = 0
            let ocalificacionfin_sup = 0

            let ponObj = []

              for(let o = 0; o < r.data[i].evcol[y].obj.length; o++){
                data.nroObj = r.data[i].evcol[y].obj.length //Pendiente con el +1
                ocalificacionmed_col = ocalificacionmed_col + r.data[i].evcol[y].obj[o].calificacionmed_col
                ocalificacionmed_sup = ocalificacionmed_sup + r.data[i].evcol[y].obj[o].calificacionmed_sup
                ocalificacionfin_col = ocalificacionfin_col + r.data[i].evcol[y].obj[o].calificacionfin_col
                ocalificacionfin_sup = ocalificacionfin_sup + r.data[i].evcol[y].obj[o].calificacionfin_sup
                let calObj = {
                  autoevaluacion: r.data[i].evcol[y].evaluacion.autoevaluacion,
                  medioano: r.data[i].evcol[y].evaluacion.medioano,
                  cal_med_col: r.data[i].evcol[y].obj[o].calificacionmed_col,
                  cal_med_sup: r.data[i].evcol[y].obj[o].calificacionmed_sup,
                  cal_fin_col: r.data[i].evcol[y].obj[o].calificacionfin_col,
                  cal_fin_sup: r.data[i].evcol[y].obj[o].calificacionfin_sup,
                  peso: r.data[i].evcol[y].obj[o].peso,
                }
                ponObj.push(calObj)
              }

            data.promObEvMedCol = (ocalificacionmed_col / data.nroObj).toFixed(2)
            data.promObEvMedSup = (ocalificacionmed_sup / data.nroObj).toFixed(2)
            data.promObEvFinCol = (ocalificacionfin_col / data.nroObj).toFixed(2)
            data.promObEvFinSup = (ocalificacionfin_sup / data.nroObj).toFixed(2)

            let ccalificacionmed_col = 0
            let ccalificacionmed_sup = 0
            let ccalificacionfin_col = 0
            let ccalificacionfin_sup = 0

            let ponCom = []

              for(let o = 0; o < r.data[i].evcol[y].com.length; o++){
                data.nroCom = r.data[i].evcol[y].com.length //Pendiente con el +1
                ccalificacionmed_col = ccalificacionmed_col + r.data[i].evcol[y].com[o].calificacionmed_col
                ccalificacionmed_sup = ccalificacionmed_sup + r.data[i].evcol[y].com[o].calificacionmed_sup
                ccalificacionfin_col = ccalificacionfin_col + r.data[i].evcol[y].com[o].calificacionfin_col
                ccalificacionfin_sup = ccalificacionfin_sup + r.data[i].evcol[y].com[o].calificacionfin_sup
                let calCom = {
                  autoevaluacion: r.data[i].evcol[y].evaluacion.autoevaluacion,
                  medioano: r.data[i].evcol[y].evaluacion.medioano,
                  cal_med_col: r.data[i].evcol[y].com[o].calificacionmed_col,
                  cal_med_sup: r.data[i].evcol[y].com[o].calificacionmed_sup,
                  cal_fin_col: r.data[i].evcol[y].com[o].calificacionfin_col,
                  cal_fin_sup: r.data[i].evcol[y].com[o].calificacionfin_sup,
                  peso: r.data[i].evcol[y].com[o].peso,
                }
                ponCom.push(calCom)                
              }
            data.promCoEvMedCol = (ccalificacionmed_col / data.nroCom).toFixed(2)
            data.promCoEvMedSup = (ccalificacionmed_sup / data.nroCom).toFixed(2)
            data.promCoEvFinCol = (ccalificacionfin_col / data.nroCom).toFixed(2)
            data.promCoEvFinSup = (ccalificacionfin_sup / data.nroCom).toFixed(2)

            let ponMed = ''
            let ponFin = ''

            for(let i = 0; i < ponCom.length; i++){
              let ponderadaMed = 0
              let ponderadaFin = 0
              if(ponCom[i].autoevaluacion == 1 && ponCom[i].medioano == 1){
                ponderadaMed = ((((ponCom[i].cal_med_col + ponCom[i].cal_med_sup) / 2) * ponCom[i].peso) / 100)
              }else if(ponCom[i].medioano == 1){
                ponderadaMed = (((ponCom[i].cal_med_sup) * ponCom[i].peso) / 100)
              }else{
                ponderadaMed = 'N/A'
                ponMed = 'N/A'
              }
              if(ponCom[i].autoevaluacion == 1){
                ponderadaFin = ((((ponCom[i].cal_fin_col + ponCom[i].cal_fin_sup) / 2) * ponCom[i].peso) / 100)
              }else{
                ponderadaFin = (((ponCom[i].cal_fin_sup) * ponCom[i].peso) / 100)
              }

              if(ponderadaMed != 'N/A'){
                ponderadaMed = ((ponderadaMed * data.vcom) / 100)
                ponMed = ((ponMed*1) + ponderadaMed).toFixed(2)
              }
                ponderadaFin = ((ponderadaFin * data.vcom) / 100)
                ponFin = ((ponFin*1) + ponderadaFin).toFixed(2)
            }

            for(let i = 0; i < ponObj.length; i++){
              let ponderadaMed = 0
              let ponderadaFin = 0
              if(ponObj[i].autoevaluacion == 1 && ponObj[i].medioano == 1){
                ponderadaMed = ((((ponObj[i].cal_med_col + ponObj[i].cal_med_sup) / 2) * ponObj[i].peso) / 100)
              }else if(ponObj[i].medioano == 1){
                ponderadaMed = (((ponObj[i].cal_med_sup) * ponObj[i].peso) / 100)
              }else{
                ponderadaMed = 'N/A'
                ponMed = 'N/A'
              }
              if(ponObj[i].autoevaluacion == 1){
                ponderadaFin = ((((ponObj[i].cal_fin_col + ponObj[i].cal_fin_sup) / 2) * ponObj[i].peso) / 100)
              }else{
                ponderadaFin = (((ponObj[i].cal_fin_sup) * ponObj[i].peso) / 100)
              }

              if(ponderadaMed != 'N/A'){
                ponderadaMed = ((ponderadaMed * data.vobj) / 100)
                ponMed = ((ponMed*1) + ponderadaMed).toFixed(2)
              }
                ponderadaFin = ((ponderadaFin * data.vobj) / 100)
                ponFin = ((ponFin*1) + ponderadaFin).toFixed(2)
            }
            data.ponMed = ponMed
            data.ponFin = ponFin
            this.dataworkAnt.push(data)
            } catch{
              console.log('No porcesada')
            }
          }
        }
      })
      .catch(error => {
        console.log(error);
      });

    
    axios
      .get(api.api + this.apiPath + '/reporteimportado')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          this.datosImport.push(r.data[i])
        }   
      })
      .catch(error => {
        console.log(error);
      });
    },
    methods: {
        toast(color, text) {
            var toast = { color, text }
            store.commit("TOAST", toast)
        },
        
        exportExcel(datosXLS) {
        let data = XLSX.utils.json_to_sheet(datosXLS)
        //data['A1'].v = 'Nombre Pinche',{
         // header: ['name','occupation']
        //}
        //data['B1'].v = 'Ocupacion'
        const workbook = XLSX.utils.book_new()
        const filename = 'evaluacion-reporte1'
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      },

      importar(){
        router.push('/evaluacionesmasivos')
      },
    },

}
</script>